import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import api from '@/api';
import AuthRepository from '../repositories/authRepository';

Vue.use(Vuex);
const UserDefault = () => ({
  token: null,
  name: 'John Leider',
  email: 'johnleider@gmail.com',
  profile: null,
  profiles: [],
  permissions: [],
  views: [],
  school: null,
  schools: [],
  avatar: null,
});

const dadosDefault = () => ({
  anoAtual: null,
  anoInicioSistema: null,
  anoSelecionado: null,
});

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: UserDefault(),
    dadosSistema: dadosDefault(),
    globalNotification: {
      snack: '',
    },
  },
  mutations: {
    AUTHENTICATE(state, { token, name }) {
      Object.assign(state.user, { token, name });
    },
    EMAIL(state, email) {
      Object.assign(state.user, { email });
    },
    STORE_PROFILES(state, profiles) {
      Object.assign(state.user, { profiles });
    },
    CHANGE_PROFILE(state, profile) {
      api.defaults.headers.Profile = profile;
      Object.assign(state.user, { profile });
    },
    STORE_SCHOOLS(state, schools) {
      Object.assign(state.user, { schools });
    },
    CHANGE_SCHOOL(state, school) {
      Object.assign(state.user, { school });
    },
    LOGOFF(state) {
      Object.assign(state.user, UserDefault());
      Object.assign(state.dadosSistema, dadosDefault());
    },
    SET_PERMISSIONS(state, { views, permissions }) {
      Object.assign(state.user, { views, permissions });
    },
    SET_AVATAR(state, avatar) {
      Object.assign(state.user, { avatar });
    },
    SET_YEAR(state, { anoAtual, anoInicioSistema }) {
      Object.assign(state.dadosSistema, {
        anoAtual,
        anoInicioSistema,
        anoSelecionado: anoAtual,
      });
    },
    SET_YEAR_SYSTEM(state, ano) {
      Object.assign(state.dadosSistema, {
        anoSelecionado: ano,
      });
    },
    SET_GLOBAL_NOTIFICATION(state, dadosNotificacao) {
      Object.assign(state.globalNotification, { ...dadosNotificacao });
    },
  },
  actions: {
    async login({ commit }, { login, password }) {
      try {
        const { token, name } = await AuthRepository.authenticate(login, password);
        if (token) {
          api.defaults.headers.Authorization = `Bearer ${token}`;
          commit('AUTHENTICATE', { token, name });
          const { results } = await AuthRepository.listprofiles();
          commit('STORE_PROFILES', results.perfis);
          commit('EMAIL', login);
          return true;
        }
        return false;
      } catch (err) {
        throw err.response.data;
      }
    },
    async logoff({ commit }) {
      commit('LOGOFF');
    },

    async atualizarperfis({commit}){
      const { results } = await AuthRepository.listprofiles();
      commit('STORE_PROFILES', results.perfis);
    },

    async alterar_perfil({ commit }, perfil) {
      commit('CHANGE_PROFILE', perfil);
      const { data } = await AuthRepository.getListSchools();
      commit('STORE_SCHOOLS', data.results.escolas);
      commit('SET_YEAR', {
        anoAtual: data.results.anoAtual,
        anoInicioSistema: data.results.anoInicio,
      });
      
      // permissoes
      const response = await AuthRepository.getListaTelas();
      commit('SET_PERMISSIONS', {
        views: response.data.results.telas,
        permissions: response.data.results.permissoes,
      });
    },
    async alterarEscola({ commit }, escola) {
      commit('CHANGE_SCHOOL', escola);
    },
    async inserirPermissoes({ commit }, permisoes) {
      commit('SET_PERMISSIONS', permisoes);
    },
    async inserirAvatar({ commit }) {
      const { data } = await AuthRepository.getAvatar();
      commit('SET_AVATAR', data.results.base64);
    },
    inserirAno({ commit }, ano) {
      commit('SET_YEAR_SYSTEM', ano);
    },
    adicionarNotificacao({ commit }, texto) {
      commit('SET_GLOBAL_NOTIFICATION', { snack: texto });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.user.token !== null;
    },
    userIsAllowed(state) {
      return (tagTela, tagTelaFuncao) => {
        if (typeof tagTela === 'undefined' || typeof tagTelaFuncao === 'undefined') { return false; }

        const tela = state.user.permissions.filter(key => key.tagtela === tagTela);
        if (tela.length <= 0) { return false; }

        return tela[0].tela_funcoes.findIndex(key => key.tagfuncaotela === tagTelaFuncao) >= 0;
      };
    },
    userIsAllowedUrl(state) {
      return urlTela => state.user.permissions.findIndex(key => key.url === urlTela) >= 0;
    },
    profiles(state) {
      return state.user.profiles;
    },
    profile(state) {
      return state.user.profile;
    },
    userDadosPerfilAtual(state) {
      const perfilatual = state.user.profile;
      if (state.user.profiles.length > 0) {
        const perfil = state.user.profiles.find(p => p.identificadorusuarioperfil === perfilatual);
        if (perfil) { return perfil; }
      }
      return {};
    },
    email(state) {
      return state.user.email;
    },
    username(state) {
      return state.user.name;
    },
    profile_name(state) {
      const perfilatual = state.user.profile;
      if (state.user.profiles.length > 0) {
        const perfil = state.user.profiles.find(p => p.identificadorusuarioperfil === perfilatual);
        return (perfil) ? perfil.nomeperfil : '';
      }
      return null;
    },
    school(state) {
      return state.user.school;
    },
    schools(state) {
      return state.user.schools;
    },
    schoolName(state) {
      const escolaatual = state.user.school;
      if (escolaatual) {
        return escolaatual.nmescola;
      }
      return null;
    },
    userPerfilTelas(state) {
      return state.user.views;
    },
    userProfessor(state) {
      if (state.user.profiles.length === 0) { return {}; }
      const perfil = state.user.profiles.find(p => p.identificadorusuarioperfil === state.user.profile);
      return (perfil) ? { cdmatric: perfil.cdmatric, cdpessoal: perfil.cdpessoal } : {};
    },
    avatar(state) {
      return state.user.avatar;
    },
    getAnoInicioSistema(state) {
      return state.dadosSistema.anoInicioSistema;
    },
    getAnoAtualServidor(state) {
      return state.dadosSistema.anoAtual;
    },
    getAnoSistema(state) {
      return state.dadosSistema.anoSelecionado;
    },
    getGlobalNotification(state) {
      return state.globalNotification;
    },
  },
});
